import * as Yup from "yup";

export const signInValidationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Please enter your Email address"),
  password: Yup.string()
    .min(8, "Must be 8 characters or more")
    .required("Please enter your password"),
});

export const passwordResetValidationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Please enter your Email address"),
});

export const resetPasswordValidationSchema = Yup.object({
  password: Yup.string()
    .min(8, "Must be 8 characters or more")
    .required("Please enter your password"),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref("password"), null], "Password don't  match")
    .required("Please enter your confirm password"),
});
